/* assets/jdm-fbt.js
   JDM FBT – add en background + toast + refresh sections (theme-native)
*/
(() => {
  const SELECTORS = {
    root: "[data-jdm-fbt][data-no-drawer]",
    submit: "[data-jdm-fbt-submit]",
    drawer: "cart-drawer",
    cartIconBubble: "#cart-icon-bubble",
    bubbleCount: "#cart-icon-bubble .cart-count-bubble span[aria-hidden='true']",
    bubbleA11y: "#cart-icon-bubble .cart-count-bubble .visually-hidden",
  };

  const SECTION_IDS = ["cart-icon-bubble", "cart-drawer"];

  // --- toast simple
  function toast(msg) {
    let t = document.querySelector("#jdm-toast");
    if (!t) {
      t = document.createElement("div");
      t.id = "jdm-toast";
      t.style.cssText = `
        position:fixed; left:50%; bottom:24px; transform:translateX(-50%);
        background:rgba(255,255,255,.96); color:#0a3954;
        border:1px solid rgba(10,57,84,.15);
        padding:10px 14px; border-radius:999px;
        font-size:14px; z-index:999999; opacity:0; transition:opacity .2s ease;
        box-shadow:0 10px 30px rgba(0,0,0,.10);
        pointer-events:none;
      `;
      document.body.appendChild(t);
    }
    t.textContent = msg;
    t.style.opacity = "1";
    clearTimeout(t._timer);
    t._timer = setTimeout(() => (t.style.opacity = "0"), 1600);
  }

  async function fetchJSON(url, options = {}) {
    const res = await fetch(url, { credentials: "same-origin", ...options });
    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      throw new Error(err.description || err.message || `HTTP ${res.status}`);
    }
    return res.json();
  }

  async function addItem(variantId) {
    return fetchJSON("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
    });
  }

  async function getCart() {
    return fetchJSON("/cart.js", { headers: { Accept: "application/json" } });
  }

  async function fetchSections(ids) {
    const params = new URLSearchParams();
    params.set("sections", ids.join(","));
    params.set("sections_url", window.location.pathname);
    const res = await fetch(`/?${params.toString()}`, { credentials: "same-origin" });
    return res.json();
  }

  function updateBubbleFallback(cart) {
    const count = String(cart.item_count || 0);
    const el = document.querySelector(SELECTORS.bubbleCount);
    if (el) el.textContent = count;

    const a11y = document.querySelector(SELECTORS.bubbleA11y);
    if (a11y) a11y.textContent = `${count} article${count === "1" ? "" : "s"}`;
  }

  // Update cart icon + drawer content. Only replace .drawer__inner contents (keep the node) so theme refs to #CartDrawer / .drawer__inner stay valid.
  async function refreshThemeCartUI() {
    const cart = await getCart();
    document.documentElement.dispatchEvent(new CustomEvent("cart:updated", { detail: { cart } }));

    const sectionsHtml = await fetchSections(SECTION_IDS);

    // 1. Update header cart icon
    const bubbleEl = document.querySelector(SELECTORS.cartIconBubble);
    const bubbleHtml = sectionsHtml["cart-icon-bubble"];
    if (bubbleEl && bubbleHtml) {
      const bubbleDoc = new DOMParser().parseFromString(bubbleHtml, "text/html");
      const bubbleSection = bubbleDoc.querySelector("#shopify-section-cart-icon-bubble") || bubbleDoc.querySelector(".shopify-section");
      if (bubbleSection) bubbleEl.innerHTML = bubbleSection.innerHTML;
      else updateBubbleFallback(cart);
    } else {
      updateBubbleFallback(cart);
    }

    // 2. Update drawer content so opening the cart shows items. Defer so theme's cart:updated handlers run first.
    //    Replace only .drawer__inner's innerHTML so the .drawer__inner node stays the same — avoids theme refs going null.
    const drawerHtml = sectionsHtml["cart-drawer"];
    if (!drawerHtml) return;
    setTimeout(() => {
      const drawerDoc = new DOMParser().parseFromString(drawerHtml, "text/html");
      const freshInner = drawerDoc.querySelector("cart-drawer .drawer__inner");
      const currentInner = document.querySelector("cart-drawer .drawer__inner");
      if (freshInner && currentInner) {
        currentInner.innerHTML = freshInner.innerHTML;
        const drawerEl = document.querySelector(SELECTORS.drawer);
        const freshDrawer = drawerDoc.querySelector("cart-drawer");
        if (drawerEl && freshDrawer) {
          drawerEl.classList.toggle("is-empty", freshDrawer.classList.contains("is-empty"));
        }
      }
    }, 0);
  }

  async function handleAdd(btn) {
    const variantId = Number(btn?.getAttribute("data-variant-id"));
    if (!variantId) return;

    const prev = btn.textContent;
    btn.disabled = true;
    btn.setAttribute("aria-busy", "true");
    btn.textContent = "Ajout…";

    try {
      await addItem(variantId);
      await refreshThemeCartUI();
      toast("Ajouté au panier 🌸");
    } catch (err) {
      console.error("[JDM FBT]", err);
      toast(err.message || "Impossible d\u2019ajouter");
    } finally {
      btn.disabled = false;
      btn.setAttribute("aria-busy", "false");
      btn.textContent = prev;
    }
  }

  // Click (capture) so theme never opens cart-drawer; we add in background and update icon only
  document.addEventListener(
    "click",
    (e) => {
      const btn = e.target?.closest?.(SELECTORS.submit);
      if (!btn) return;
      const root = btn.closest(SELECTORS.root);
      if (!root) return;

      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();

      handleAdd(btn);
    },
    true
  );

  // Fallback if form is submitted (e.g. Enter key)
  document.addEventListener(
    "submit",
    (e) => {
      const form = e.target;
      const root = form?.closest?.(SELECTORS.root);
      if (!root || !form.querySelector(SELECTORS.submit)) return;
      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      handleAdd(form.querySelector(SELECTORS.submit));
    },
    true
  );
})();
